import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import SiteGate from "@/components/SiteGate";

import Home from "@/pages/Home";
import Lincolnshire from "@/pages/Lincolnshire";
import Massachusetts from "@/pages/Massachusetts";
import Story from "@/pages/Story";
import Story1630 from "@/pages/Story1630";
import Visit from "@/pages/Visit";
import VisitLincolnshire from "@/pages/VisitLincolnshire";
import VisitMassachusetts from "@/pages/VisitMassachusetts";
import StumpToCommon from "@/pages/StumpToCommon";
import Made from "@/pages/Made";
import ListingDetail from "@/pages/ListingDetail";
import Trade from "@/pages/Trade";
import Tourism from "@/pages/Tourism";
import Forum from "@/pages/Forum";
import ForumBoard from "@/pages/ForumBoard";
import ForumThread from "@/pages/ForumThread";
import Exchange from "@/pages/Exchange";
import TwentyThirty from "@/pages/TwentyThirty";
import Journal from "@/pages/Journal";
import Article from "@/pages/Article";
import Join from "@/pages/Join";
import Advertise from "@/pages/Advertise";
import About from "@/pages/About";
import Press from "@/pages/Press";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import SignIn from "@/pages/SignIn";
import SignUp from "@/pages/SignUp";
import Account from "@/pages/Account";
import EditListing from "@/pages/EditListing";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";
import { RedirectTo } from "@/pages/Redirect";

function App() {
  return (
    <AuthProvider>
      <SiteGate>
        <BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#FFFAF3",
              border: "1px solid #CDA434",
              color: "#1B2430",
              borderRadius: "0",
              fontFamily: "'Open Sans', sans-serif",
            },
          }}
        />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/lincolnshire" element={<Lincolnshire />} />
            <Route path="/massachusetts" element={<Massachusetts />} />
            <Route path="/story" element={<Story />} />
            <Route path="/story/1630" element={<Story1630 />} />
            <Route path="/visit" element={<Visit />} />
            <Route path="/visit/lincolnshire" element={<VisitLincolnshire />} />
            <Route path="/visit/massachusetts" element={<VisitMassachusetts />} />
            <Route path="/visit/itineraries/stump-to-common" element={<StumpToCommon />} />
            <Route path="/made" element={<Made />} />
            <Route path="/made/:slug" element={<ListingDetail />} />
            <Route path="/trade" element={<Trade />} />
            <Route path="/tourism" element={<Tourism />} />
            <Route path="/forum" element={<Forum />} />
            <Route path="/forum/board/:sector" element={<ForumBoard />} />
            <Route path="/forum/thread/:id" element={<ForumThread />} />
            <Route path="/exchange" element={<Exchange />} />
            <Route path="/2030" element={<TwentyThirty />} />
            <Route path="/events" element={<RedirectTo to="/2030" />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<Article />} />
            <Route path="/join" element={<Join />} />
            <Route path="/advertise" element={<Advertise />} />
            <Route path="/about" element={<About />} />
            <Route path="/press" element={<Press />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/account" element={<Account />} />
            <Route path="/account/listing/edit" element={<EditListing />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </SiteGate>
    </AuthProvider>
  );
}

export default App;
